/*!

=========================================================
* Material Dashboard React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import DashboardIcons from "@material-ui/icons/Dashboard";
import PeopleIcon from "@material-ui/icons/People";
import SettingIcon from "@material-ui/icons/Settings";
import DownloadForOfflineIcon from "@material-ui/icons/CloudDownload";
import InvoiceIcon from "@material-ui/icons/Receipt";
import FeaturedPlayListIcon from "@material-ui/icons/FeaturedPlayList";
import ViewDayIcon from "@material-ui/icons/ViewDay";
// import MenuBookIcon from "@material-ui/icons/MenuBook";

import WorkIcon from "@material-ui/icons/Work";
import {
  basePath,
  baseRoutes,
  dpBaseRoutes,
  providerUserBaseRoutes,
  providerBaseRoutes,
} from "base-routes";
import Profile from "views/Profile/Profile";
import InDevelopment from "views/InDevelopment/InDevlopment";
import TermsComponent from "views/CmsPages/TermsComponent";
import BAAComponent from "views/CmsPages/BAAComponent";

import FacilityList from "views/Facility/index";
import DischargePlannerList from "views/DischargePlanner/index";
import ProviderList from "views/Provider/index";
import ManageFacilityUsers from "views/facilityAdmin/ManageFacilityUsers";
import FacilitySettings from "views/facilityAdmin/FacilitySettings";
import FacilityReport from "views/facilityAdmin/FacilityReport";
import OrgFacilityList from "views/orgViews/OrgFacilityList";
import OrgGroups from "views/orgViews/OrgGroups";
import OrgFacilityUsers from "views/orgViews/OrgFacilityUsers";
import RegionGroups from "views/regionGroups/RegionGroups";
import ManagementHierarchy from "views/managementHierarchy/ManagementHierarchy";
import Managers from "views/managers/Managers";
import OrgExecutiveDashboard from "views/orgViews/OrgExecutiveDashboard";
import { FACILITY_ADMIN, ORG_ADMIN } from "__helpers/constants";
import ConsentDocuments from "views/ConsentDocuments/index";
import MaxAllyUserReport from "views/maxAllyUserReport/index";
import DescriptionIcon from "@material-ui/icons/Description";

import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import ReceiptIcon from "@material-ui/icons/Receipt";

// discharge planner component
import patientList from "views/dpViews/PatientDashboard/PatientDashboard";
import calendar from "views/dpViews/Calendar";
import pcc3LeggedAuth from "components/3LeggedAuth/Pcc3LeggedAuth";
import singlePatientInfo from "views/dpViews/SinglePatientDetail/SinglePatientDetail";

import ProviderUsers from "views/ProviderUser/index";
import FindProvider from "views/FindProvider/index";
import DPProfile from "views/dpViews/DPProfile/DPProfile";

// provider & provider user component
import ProviderPatientDashboard from "views/providerViews/PatientDashboard/ProviderPatientDashboard";
import ProviderDashboard from "views/providerViews/PatientDashboard/ProviderPatientDashboard";
import MyPatients from "views/providerViews/MyPatients/MyPatients";
import ProviderProfile from "views/providerViews/ProviderProfile/ProviderProfile";
import AdminProviderProfile from "views/providerViews/AdminProviderProfile/AdminProviderProfile.jsx";
import Notification from "views/Notifications/Notifications";
import BundlePatient from "views/BundlePatient/index";
import ReferralReports from "views/referralReports/index";
import ProviderEngagementReport from "views/providerEngagementReport/index";
import SponsoredProviderMetrics from "views/sponsoredProviderMetrics/index";
import OrganizationReport from "views/organizationReport/index";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import StarIcon from "@material-ui/icons/Star";
import BusinessIcon from "@material-ui/icons/Business";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import Invoice from "views/invoice/index";

import profile from "views/Provider/profile";
import TaskTemplate from "views/dpViews/SinglePatientDetail/TaskTemplate";
import SurveyList from "views/dpViews/SinglePatientDetail/SurveyList";
import surveyTemplate from "views/dpViews/SinglePatientDetail/surveyTemplate";
import AddNewSurvey from "views/dpViews/SinglePatientDetail/AddNewSurvey";
import EditSurvey from "views/dpViews/SinglePatientDetail/EditSurvey";
import PreviewSurvey from "views/dpViews/PatientDashboard/PreviewSurvey"

import ReferralReportsDischargePlanner from "views/dpViews/SinglePatientDetail/ReferralReportsDischargePlanner";

// import userIcon from "assets/img/icons/users.svg";

const dashboardRoutes = [
  {
    path: baseRoutes.profile.path,
    name: baseRoutes.profile.pathName,
    icon: DashboardIcons,
    component: Profile,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.regionGroups.path,
    name: baseRoutes.regionGroups.pathName,
    icon: BusinessIcon,
    component: RegionGroups,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.managementHierarchy.path,
    name: baseRoutes.managementHierarchy.pathName,
    icon: AccountTreeIcon,
    component: ManagementHierarchy,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.managers.path,
    name: baseRoutes.managers.pathName,
    icon: PeopleIcon,
    component: Managers,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.facilityList.path,
    name: baseRoutes.facilityList.pathName,
    icon: DashboardIcons,
    component: FacilityList,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.dischargePlanner.path,
    name: baseRoutes.dischargePlanner.pathName,
    icon: MeetingRoomIcon,
    component: DischargePlannerList,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.provider.path,
    name: baseRoutes.provider.pathName,
    icon: ReceiptIcon,
    component: ProviderList,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.providerUsers.path,
    name: baseRoutes.providerUsers.pathName,
    icon: PeopleIcon,
    component: ProviderUsers,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.referralReports.path,
    name: baseRoutes.referralReports.pathName,
    icon: DownloadForOfflineIcon,
    component: ReferralReports,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.maxAllyUserReport.path,
    name: baseRoutes.maxAllyUserReport.pathName,
    icon: PeopleIcon,
    component: MaxAllyUserReport,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.providerEngagementReport.path,
    name: baseRoutes.providerEngagementReport.pathName,
    icon: TrendingUpIcon,
    component: ProviderEngagementReport,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.sponsoredProviderMetrics.path,
    name: baseRoutes.sponsoredProviderMetrics.pathName,
    icon: StarIcon,
    component: SponsoredProviderMetrics,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.organizationReport.path,
    name: baseRoutes.organizationReport.pathName,
    icon: BusinessIcon,
    component: OrganizationReport,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.invoice.path,
    name: baseRoutes.invoice.pathName,
    icon: InvoiceIcon,
    component: Invoice,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.setting.path,
    name: baseRoutes.setting.pathName,
    icon: SettingIcon,
    component: InDevelopment,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: baseRoutes.consentDocuments.path,
    name: baseRoutes.consentDocuments.pathName,
    icon: DescriptionIcon,
    component: ConsentDocuments,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: "/find-provider",
    name: "Dashboard",
    icon: DashboardIcons,
    component: FindProvider,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.providerProfile.path,
    name: baseRoutes.providerProfile.pathName,
    icon: PeopleIcon,
    component: AdminProviderProfile,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.providerUser.path,
    name: baseRoutes.providerUser.pathName,
    icon: PeopleIcon,
    component: profile,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: "/",
    name: baseRoutes.dashboard.pathName,
    icon: DashboardIcons,
    component: FacilityList,
    layout: "/admin",
    basePath: basePath,
    showInSideBar: false,
  },
];

export default dashboardRoutes;

export const dpRoutes = [
  {
    path: baseRoutes.profile.path,
    name: baseRoutes.profile.pathName,
    icon: DashboardIcons,
    component: DPProfile,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: dpBaseRoutes.pcc3LeggedAuth.path,
    name: dpBaseRoutes.pcc3LeggedAuth.pathName,
    icon: DashboardIcons,
    component: pcc3LeggedAuth,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: dpBaseRoutes.calendar.path,
    name: dpBaseRoutes.calendar.pathName,
    icon: DashboardIcons,
    component: calendar,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: dpBaseRoutes.patientList.path,
    name: dpBaseRoutes.patientList.pathName,
    icon: DashboardIcons,
    component: patientList,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.singlePatientInfo.path,
    name: dpBaseRoutes.singlePatientInfo.pathName,
    icon: DashboardIcons,
    component: singlePatientInfo,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.TaskTemplate.path,
    name: dpBaseRoutes.TaskTemplate.pathName,
    icon: DashboardIcons,
    component: TaskTemplate,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
   {
    path: dpBaseRoutes.SurveyList.path,
    name: dpBaseRoutes.SurveyList.pathName,
    icon: DashboardIcons,
    component: SurveyList,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.surveyTemplate.path,
    name: dpBaseRoutes.surveyTemplate.pathName,
    icon: DashboardIcons,
    component: surveyTemplate,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.AddNewSurvey.path,
    name: dpBaseRoutes.AddNewSurvey.pathName,
    icon: DashboardIcons,
    component: AddNewSurvey,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.EditSurvey.path,
    name: dpBaseRoutes.EditSurvey.pathName,
    icon: DashboardIcons,
    component: EditSurvey,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.PreviewSurvey.path,
    name: dpBaseRoutes.PreviewSurvey.pathName,
    icon: DashboardIcons,
    component: PreviewSurvey,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.ReferralReportsDischargePlanner.path,
    name: dpBaseRoutes.ReferralReportsDischargePlanner.pathName,
    icon: DashboardIcons,
    component: ReferralReportsDischargePlanner,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.notification.path,
    name: dpBaseRoutes.notification.pathName,
    icon: DashboardIcons,
    component: Notification,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.terms.path,
    name: baseRoutes.terms.pathName,
    icon: SettingIcon,
    component: TermsComponent,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.baa.path,
    name: baseRoutes.baa.pathName,
    icon: SettingIcon,
    component: BAAComponent,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: dpBaseRoutes.bundlePatient.path,
    name: dpBaseRoutes.bundlePatient.pathName,
    icon: SettingIcon,
    component: BundlePatient,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: providerBaseRoutes.profile.path,
    name: providerBaseRoutes.profile.pathName,
    icon: DashboardIcons,
    component: ProviderProfile,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: dpBaseRoutes.manageFacilityUsers.path,
    name: dpBaseRoutes.manageFacilityUsers.pathName,
    icon: PeopleIcon,
    component: ManageFacilityUsers,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
    requiredAnyRole: [FACILITY_ADMIN, ORG_ADMIN],
  },
  {
    path: dpBaseRoutes.facilitySettings.path,
    name: dpBaseRoutes.facilitySettings.pathName,
    icon: SettingIcon,
    component: FacilitySettings,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
    requiredAnyRole: [FACILITY_ADMIN, ORG_ADMIN],
  },
  {
    path: dpBaseRoutes.facilityReport.path,
    name: dpBaseRoutes.facilityReport.pathName,
    icon: DashboardIcons,
    component: FacilityReport,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: true,
    requiredAnyRole: [FACILITY_ADMIN, ORG_ADMIN],
  },
  {
    path: "/",
    name: dpBaseRoutes.dashboard.pathName,
    icon: DashboardIcons,
    component: patientList,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
];

// B2B Org Admin shell (own layout WITH a sidebar — the DP shell has none).
// Lands on the org facility list; manages co-admins of their org.
// NOTE: basePath is intentionally "" so the route paths are exactly the /org/*
// URLs we redirect to (index.js mounts this layout on a plain "/org" path, with
// no REACT_APP_BASE_PATH prefix). Mixing in basePath here would make the content
// Switch paths (basePath + path) never match the actual URL.
export const orgRoutes = [
  {
    path: dpBaseRoutes.orgExecutiveDashboard.path,
    name: dpBaseRoutes.orgExecutiveDashboard.pathName,
    icon: TrendingUpIcon,
    component: OrgExecutiveDashboard,
    layout: "/org",
    basePath: "",
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.orgFacilities.path,
    name: dpBaseRoutes.orgFacilities.pathName,
    icon: BusinessIcon,
    component: OrgFacilityList,
    layout: "/org",
    basePath: "",
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.orgGroups.path,
    name: dpBaseRoutes.orgGroups.pathName,
    icon: AccountTreeIcon,
    component: OrgGroups,
    layout: "/org",
    basePath: "",
    showInSideBar: true,
  },
  {
    path: dpBaseRoutes.orgFacilityUsers.path,
    name: dpBaseRoutes.orgFacilityUsers.pathName,
    icon: PeopleIcon,
    component: OrgFacilityUsers,
    layout: "/org",
    basePath: "",
    showInSideBar: true,
  },
  {
    path: baseRoutes.profile.path,
    name: baseRoutes.profile.pathName,
    icon: DashboardIcons,
    component: Profile,
    layout: "/org",
    basePath: "",
    showInSideBar: false,
  },
  {
    // Org Admin landing = Executive Dashboard (auto-fires last-30-days report).
    path: "/",
    name: dpBaseRoutes.orgExecutiveDashboard.pathName,
    icon: TrendingUpIcon,
    component: OrgExecutiveDashboard,
    layout: "/org",
    basePath: "",
    showInSideBar: false,
  },
];
export const providerRoutes = [
  {
    path: providerBaseRoutes.profile.path,
    name: providerBaseRoutes.profile.pathName,
    icon: DashboardIcons,
    component: ProviderProfile,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: providerBaseRoutes.patientList.path,
    name: providerBaseRoutes.patientList.pathName,
    icon: DashboardIcons,
    component: ProviderPatientDashboard,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: providerBaseRoutes.myPatients.path,
    name: providerBaseRoutes.myPatients.pathName,
    icon: DashboardIcons,
    component: MyPatients,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },

  {
    path: providerBaseRoutes.notification.path,
    name: providerBaseRoutes.notification.pathName,
    icon: DashboardIcons,
    component: Notification,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.terms.path,
    name: baseRoutes.terms.pathName,
    icon: SettingIcon,
    component: TermsComponent,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.baa.path,
    name: baseRoutes.baa.pathName,
    icon: SettingIcon,
    component: BAAComponent,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: "/",
    name: providerBaseRoutes.dashboard.pathName,
    icon: DashboardIcons,
    component: ProviderPatientDashboard,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },
];
export const providerUserRoutes = [
  {
    path: baseRoutes.profile.path,
    name: baseRoutes.profile.pathName,
    icon: DashboardIcons,
    component: Profile,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: providerUserBaseRoutes.patientList.path,
    name: providerUserBaseRoutes.patientList.pathName,
    icon: DashboardIcons,
    component: ProviderDashboard,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: true,
  },
  {
    path: providerBaseRoutes.myPatients.path,
    name: providerBaseRoutes.myPatients.pathName,
    icon: DashboardIcons,
    component: MyPatients,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: providerBaseRoutes.notification.path,
    name: providerBaseRoutes.notification.pathName,
    icon: DashboardIcons,
    component: Notification,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.terms.path,
    name: baseRoutes.terms.pathName,
    icon: SettingIcon,
    component: TermsComponent,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: baseRoutes.baa.path,
    name: baseRoutes.baa.pathName,
    icon: SettingIcon,
    component: BAAComponent,
    layout: "/DP",
    basePath: basePath,
    showInSideBar: false,
  },
  {
    path: "/",
    name: providerUserBaseRoutes.dashboard.pathName,
    icon: DashboardIcons,
    component: ProviderDashboard,
    layout: "/Provider",
    basePath: basePath,
    showInSideBar: false,
  },
];
